import React from "react";
import { PrimaryLinkStyle as PrimaryLink } from "./BaseLink";

export const Link = (props) => {
	const { text, ariaHidden } = props;

	return (
		<PrimaryLink ariaHidden={ariaHidden} {...props}>
			<span>{text}</span>
		</PrimaryLink>
	);
};
